<template>
  <vs-table :data="data">
    <template slot="header">
      <vs-button
        color="success"
        type="filled"
        icon-pack="feather"
        icon="icon-file-plus"
        class="mx-2"
        @click="addItem"
        >{{ $t('new') | capitalize }}
      </vs-button>

      <div class="con-input-search vs-table--search">
        <input
          class="input-search vs-table--search-input"
          type="text"
          v-model="text"
          @keypress.enter="search"
        />
        <vs-icon icon="search"></vs-icon>
      </div>
    </template>
    <template slot="thead">
      <vs-th>
        {{ $t('name') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('actions') | capitalize }}
      </vs-th>
    </template>

    <template slot-scope="{ data }">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
        <vs-td :data="data[indextr].name">
          {{ data[indextr].name }}
        </vs-td>

        <vs-td :data="data[indextr]">
          <action-icon
            icon="EditIcon"
            :tooltip="$t('edit')"
            @click="editItem(data[indextr])"
          />
          <!-- <action-icon
            icon="TrashIcon"
            :tooltip="$t('delete')"
            @click="confirmDelete(data[indextr])"
          /> -->
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>
  
  <script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import ThSort from '@/views/components/ThSort'
import mixins from '@/mixins'

export default {
  components: {
    ActionIcon,
    ThSort,
  },
  data() {
    return {
      text: '',
      selected: {},
    }
  },
  methods: {
    addItem() {
      this.$emit('add')
    },
    editItem(item) {
      this.$emit('edit', item)
    },
    confirmDelete(item) {
      this.selected = item
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$i18n.messages[this.$i18n.locale].confirm,
        text: this.$i18n.messages[this.$i18n.locale].confirm_message,
        acceptText: this.$i18n.messages[this.$i18n.locale].yes,
        cancelText: this.$i18n.messages[this.$i18n.locale].cancel,
        accept: this.deleteItem,
      })
    },
    deleteItem() {
      this.$emit('delete', this.selected)
    },
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
    search() {
      this.$emit('search', this.text)
    },
    handleClickSort(e) {
      this.$emit('sort', e)
    },
  },
  mixins: [mixins],
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
  
  <style>
</style>
  